<div class="d-flex justify-content-between align-items-center mt-2">
  <button
    mat-icon-button
    [disabled]="paginator.pageNumber <= 1"
    (click)="updatePage(paginator.pageNumber - 1)"
  >
    <mat-icon>{{
      htmlDirection === 'rtl' ? 'chevron_right' : 'chevron_left'
    }}</mat-icon>
  </button>
  <span>{{
    'page_of_total'
      | translate
        : {
            page: (paginator.pageNumber | numberTranslate),
            total: (paginator.totalPages | numberTranslate),
          }
  }}</span>
  <button
    mat-icon-button
    [disabled]="paginator.pageNumber >= paginator.totalPages"
    (click)="updatePage(paginator.pageNumber + 1)"
  >
    <mat-icon>{{
      htmlDirection === 'rtl' ? 'chevron_left' : 'chevron_right'
    }}</mat-icon>
  </button>
</div>
